module.exports = __webpack_public_path__ + "img/shop2.2ce0cc78.jpg";